import { IslandComponent } from '@island-runtime/types';

/**
 * `data-react-island="SubscriptionPopup"` — renders nothing. The island root
 * (`island-runtime/IslandRoot.tsx`) mounts `Popups` / `Toasts` on every page
 * that has at least one island; this one exists for pages with no other island
 * (the profile, the expert-session order form), so that the root is created at
 * all and the host page can open the paywall through `AiTools.Popups`
 * (`usePopupHostApi`).
 */
const SubscriptionPopupIsland: IslandComponent = () => null;

export default SubscriptionPopupIsland;
